export const vf = {

  // 入力内容を確認するボタン
  verifyExecBtn: document.getElementById('verifyExecBtn'),

  // 内容を送信するボタン
  submitExecBtn: document.getElementById('submitExecBtn'),

  // 入力画面にもどるボタン
  close: document.getElementById('verifyCloseBtn'),

  // 確認画面モーダルウィンドウ
  verifyWrapper: document.getElementById('verifyWrapper'),

  // 確認画面のコンテンツ
  verifyContents: document.getElementById('verifyContents'),

  // 確認画面モーダルウィンドウの Wrapper に付与するモーダルウィンドウを表示するクラス名
  verifyOpenClass: 'form-verify-visible'

};



export const vfClassName = {
  parent        : '.vf-parent',
  title         : '.vf-title',
  subtitleParent: '.vf-parent-subtitle',
  subtitle      : '.vf-subtitle',
  valid         : 'valid',
  error         : 'error'
};



// フォーム要素のタイプの配列
export const typeArray = [
  [ 'text', 'number', 'password', 'tel', 'url', 'textarea' ],
  [ 'select-one', 'radio', 'checkbox' ]
];
